import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats')({
  beforeLoad: ({ context, preload }) => {
    context.validateAppPermission('THREATS', preload);
  },
});
